import { t as createLogger } from "./app.shared-CmP4XLF_.js";

var log = createLogger("error-toast");

var error_toast_default = (() => {
    const customElementName = "error-toast";
    const DEFAULT_DURATION_MS = 5e3;
    if (customElements.get(customElementName)) return;
    class ErrorToast extends HTMLElement {
        constructor() {
            super();
            this.dismissTimer = null;
            this.handleShow = this.handleShow.bind(this);
            this.handleHide = this.handleHide.bind(this);
            this.handleCartError = this.handleCartError.bind(this);
            this.handleClick = this.handleClick.bind(this);
        }
        connectedCallback() {
            document.addEventListener("toast:show", this.handleShow);
            document.addEventListener("toast:hide", this.handleHide);
            document.addEventListener("cart:error", this.handleCartError);
            this.addEventListener("click", this.handleClick);
            this.setAttribute("aria-hidden", "true");
        }
        disconnectedCallback() {
            document.removeEventListener("toast:show", this.handleShow);
            document.removeEventListener("toast:hide", this.handleHide);
            document.removeEventListener("cart:error", this.handleCartError);
            this.removeEventListener("click", this.handleClick);
            this._clearDismissTimer();
        }
        handleShow(event) {
            const {message: message, duration: duration} = event.detail || {};
            if (!message) return;
            const messageEl = this.querySelector("[data-toast-message]");
            if (messageEl) messageEl.textContent = message;
            this.dataset.active = "true";
            this.setAttribute("aria-hidden", "false");
            this._clearDismissTimer();
            const ms = Number(duration);
            if (Number.isFinite(ms) && ms > 0) this.dismissTimer = window.setTimeout(() => this.hide(), ms); else this.dismissTimer = window.setTimeout(() => this.hide(), DEFAULT_DURATION_MS);
        }
        hide() {
            this._clearDismissTimer();
            delete this.dataset.active;
            this.setAttribute("aria-hidden", "true");
        }
        handleHide() {
            this.hide();
        }
        handleClick(event) {
            if (event.target.closest("[data-toast-close]")) this.hide();
        }
        handleCartError(event) {
            const {action: action, error: error} = event.detail || {};
            const strings = window.MBF?.strings?.cart || {};
            const errors = strings.errors || {};
            if (error?.duplicate) {
                log("events", "suppressed duplicate cart error", {
                    action: action
                });
                return;
            }
            let key;
            if (error?.name === "TimeoutError") key = "timeout"; else if (error?.status === 429) key = "rateLimited"; else if (error?.status === 422 && /are in your cart/i.test(error.description || "")) key = "maxInCart"; else if (!navigator.onLine) key = "offline";
            let message = key ? errors[key] : void 0;
            if (!message && action === "add") message = errors.add; else if (!message && (action === "change" || action === "update")) message = errors.update;
            if (!message) message = strings.error;
            if (!message) {
                log("errors", "no error message resolved", {
                    action: action
                });
                return;
            }
            log("events", "cart error toast shown", {
                action: action,
                resolved: key || "action-fallback",
                status: error?.status
            });
            this.handleShow({
                detail: {
                    message: message
                }
            });
        }
        _clearDismissTimer() {
            if (this.dismissTimer) {
                clearTimeout(this.dismissTimer);
                this.dismissTimer = null;
            }
        }
    }
    customElements.define(customElementName, ErrorToast);
})();